import { Box, Group, Stack, Text, ThemeIcon } from '@mantine/core';
import type { ReactElement } from 'react';
import { SurfaceCard } from '@/design/SurfaceCard';
import type { DevelopmentPlan } from './InsightsTypes';

interface InsightsPlanSectionProps {
    plan: DevelopmentPlan;
}

/** Personal Development Plan — one development goal per fluency category, weakest first. */
export default function InsightsPlanSection({ plan }: InsightsPlanSectionProps): ReactElement {
    const tokens = { solid: 'var(--bm-color-brand-accent)', soft: 'var(--bm-color-brand-soft)', text: 'var(--bm-color-brand-accent)', border: 'var(--bm-color-brand-border)' };
    return (
        <SurfaceCard $padding="lg">
            <Text fw={700} mb="lg">
                {plan.title}
            </Text>
            <Stack gap="lg">
                {plan.assignments.map((assignment, i) => (
                    <Group key={assignment.id} gap="sm" align="flex-start" wrap="nowrap">
                        <ThemeIcon size={22} radius="xl" style={{ background: tokens.soft, color: tokens.text, flexShrink: 0 }}>
                            <Text size="xs" fw={700}>
                                {i + 1}
                            </Text>
                        </ThemeIcon>
                        <Box>
                            <Text fw={600} size="sm">
                                {assignment.title}
                            </Text>
                            <Text size="xs" c="dimmed" mt={2} style={{ lineHeight: 1.5 }}>
                                {assignment.description}{' '}
                                <Text component="span" size="xs" fw={700} style={{ color: tokens.text }}>
                                    Target: {assignment.metricTarget}
                                </Text>
                            </Text>
                        </Box>
                    </Group>
                ))}
            </Stack>
        </SurfaceCard>
    );
}
